/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  anotherDevice: {
    defaultMessage: 'Open on another device',
    id: 'AwaitingMobileBankIdAuthenticationTarget.anotherDevice',
  },
  instructions: {
    defaultMessage: 'Sign your payment',
    id: 'AwaitingMobileBankIdAuthenticationTarget.instructions',
  },
  thisDevice: {
    defaultMessage: 'Open on this device',
    id: 'AwaitingMobileBankIdAuthenticationTarget.thisDevice',
  },
  connectTitle: {
    defaultMessage: 'Connect your bank',
    id: 'AwaitingMobileBankIdAuthenticationTarget.connectTitle',
  },
  openMobileBankId: {
    defaultMessage: 'Open Mobile BankID',
    id: 'AwaitingMobileBankIdAuthenticationTarget.openMobileBankId',
  },
});
